export const PREDICTION_KEY = 'PREDICTION'
